import {connect} from "react-redux";
import LeBlog from "../../../components/Home/Pages/PepiteInfos/LeBlog";

const MapStateToProps = (state) => ({
    firstsPostsOfArray: state.posts.firstsPostsOfArray,
    searchPostValue: state.posts.searchPostValue,
    postsList: state.posts.searchPost,
});

const MapDispatchToProps = (dispatch) => ({});

export default connect(MapStateToProps, MapDispatchToProps)(LeBlog);